import type { Columns } from '@/components/table/types';
import type { AWSResource } from '@/types';
import { capitalize } from '@/utils/lodash.util';

/**
 * Builds column definitions for AWSResource entity tables
 *
 * Returns columns for:
 * - resourceType: Type of AWS resource (EC2, S3, etc.)
 * - displayName: Human-readable name
 * - identifier: Full resource identifier (ARN)
 *
 * @returns Column definitions for TanStack Table
 *
 * @example
 * const columns = buildAWSResourceColumns();
 * // Returns array with resourceType, displayName, and identifier columns
 */
export function buildAWSResourceColumns(): Columns<AWSResource> {
  return [
    {
      id: 'resourceType',
      label: 'Resource Type',
      cell: (item: AWSResource) =>
        item?.resourceType ? capitalize(item.resourceType) : '-',
    },
    {
      id: 'displayName',
      label: 'Name',
      cell: (item: AWSResource) => item?.displayName || '-',
    },
    {
      id: 'identifier',
      label: 'Identifier',
      cell: (item: AWSResource) => item?.identifier || item?.name || '-',
    },
  ];
}
